// extracted by mini-css-extract-plugin
module.exports = {"notificationItem":"Notification_notificationItem__3z7Bx","selected":"Notification_selected__3VOUv","dropOver":"Notification_dropOver__3p4rs"};